module.exports = __webpack_public_path__ + "static/media/mobile_logo.73b3c752.svg";